// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1783589901043
      var cssReload = require("E:/project/fashang/cqykdx/student_pc/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  